import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getEmpresaSelecionada, removeEmpresaSelecionada } from '../../util/empresaSelecionada'
import { logoutUser } from '../../actions/util/authenticationJwtActions'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras'
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada'
import { isAmbienteDev } from '../../util/applicationContext'
import selecionarRota from '../../actions/rota/selecionarRota'
import limparItinerarios from '../../actions/itinerario/limparItinerarios'
import moment from 'moment'
import carregarItinerariosOffline from '../../actions/viagem/carregarItinerariosOffline'
import { showSuccessMsg, showInfoMsg, showErrorMsg } from '../../util/messagesUtil'

export const firstLetter = nomeUsuario => (nomeUsuario ? nomeUsuario.charAt(0) : '')

export const secondLetter = (nomeUsuario) => {
  if (nomeUsuario) {
    const parts = nomeUsuario.split(' ')
    if (parts.length > 1) {
      return parts[1] ? parts[1].charAt(0) : ''
    }
  }
  return ''
}

export const recuperaEmpresaSelecionada = () => getEmpresaSelecionada()

export class BarraNavegacao extends Component {
  constructor (props) {
    super(props)
    this.state = { dropdownOpen: false, carregandoOffline: false }
    this.dropdownRef = React.createRef()
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleOutsideClick)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleOutsideClick)
  }

  handleOutsideClick (e) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
      this.setState({ dropdownOpen: false })
    }
  }

  handleLogout () {
    this.props.logoutUser()
    removeEmpresaSelecionada()
    this.props.history.replace('/login')
  }

  carregarParaOffline () {
    const { empresaSelecionada, origem, destino, dataIda } = this.props
    if (!empresaSelecionada || !empresaSelecionada.id) return
    this.setState({ carregandoOffline: true, dropdownOpen: false })
    const dataSelecionada = dataIda ? moment(dataIda).format('YYYY-MM-DD') : null
    const origemId = origem ? origem.id : null
    const destinoId = destino ? destino.id : null
    carregarItinerariosOffline(empresaSelecionada.id, dataSelecionada, origemId, destinoId)
      .then(resultado => {
        this.setState({ carregandoOffline: false })
        if (resultado.carregados > 0) {
          showSuccessMsg(`${resultado.carregados} rota(s) carregada(s) para modo offline.`)
        } else {
          showInfoMsg('Nenhuma rota encontrada para carregar.')
        }
      })
      .catch(() => {
        this.setState({ carregandoOffline: false })
        showErrorMsg('Erro ao carregar itinerários para modo offline.')
      })
  }

  mudarAtuacao () {
    this.props.alterarEmpresaSelecionada(null)
    this.props.selecionarRota([])
    this.props.limparItinerarios()
    this.props.history.push('/selecao-empresa')
  }

  saudacao () {
    const h = new Date().getHours()
    if (h < 12) return 'Bom dia,'
    if (h < 18) return 'Boa tarde,'
    return 'Boa noite,'
  }

  renderDropdown () {
    const { dropdownOpen } = this.state
    if (!dropdownOpen) return null
    return (
      <div className="vx-user-dropdown" ref={this.dropdownRef}>
        <div className="vx-user-dropdown-header">
          <div className="vx-user-dropdown-name">{this.props.nomeUsuario}</div>
        </div>

        {this.props.online && (
          <button
            className="vx-user-dropdown-item"
            data-toggle="modal"
            data-target="#modalAlterarSenhaUsuario"
            onClick={() => this.setState({ dropdownOpen: false })}
          >
            <i className="material-icons">lock</i>
            Alterar senha
          </button>
        )}

        {this.props.online && this.props.empresas && this.props.empresas.length > 1 && (
          <button
            className="vx-user-dropdown-item"
            onClick={() => { this.setState({ dropdownOpen: false }); this.mudarAtuacao() }}
          >
            <i className="material-icons">swap_horiz</i>
            Mudar empresa
          </button>
        )}

        {this.props.online && this.props.empresaSelecionada && this.props.empresaSelecionada.habilitadoTef && (
          <a
            href="https://admin-vexado-producao-app-tef.s3.sa-east-1.amazonaws.com/VexadoPDV-1.0.0.msi"
            className="vx-user-dropdown-item"
            onClick={() => this.setState({ dropdownOpen: false })}
          >
            <i className="material-icons">download</i>
            Vexado-pdv v1.0
          </a>
        )}

        {this.props.online && this.props.empresaSelecionada && (
          this.props.empresaSelecionada.habilitadoVendaOffline ||
          this.props.empresaSelecionada.habilitadoVendaUrbana ||
          this.props.empresaSelecionada.habilitadoEncomendaAvulsa
        ) && (
          <button
            className="vx-user-dropdown-item"
            onClick={() => this.carregarParaOffline()}
            disabled={this.state.carregandoOffline}
            title="Carrega todas as rotas do dia para funcionar sem internet"
          >
            <i className="material-icons">
              {this.state.carregandoOffline ? 'hourglass_empty' : 'offline_pin'}
            </i>
            {this.state.carregandoOffline ? 'Carregando...' : 'Carregar Offline'}
          </button>
        )}

        <div className="vx-user-dropdown-divider" />

        <button
          id="item-sair"
          className="vx-user-dropdown-item"
          onClick={() => { this.setState({ dropdownOpen: false }); this.handleLogout() }}
          style={{ color: '#d32f2f', whiteSpace: 'nowrap' }}
        >
          <i className="material-icons" style={{ color: '#d32f2f' }}>power_settings_new</i>
          Sair do Sistema
        </button>
      </div>
    )
  }

  render () {
    const { siglaUsuario, nomeUsuario, empresaSelecionada } = this.props
    const dev = isAmbienteDev()

    const nomeEmpresa = empresaSelecionada
      ? (dev ? empresaSelecionada.nomeFantasia : empresaSelecionada.nomeFantasia) || ''
      : ''

    const podeTrocarEmpresa = this.props.empresas && this.props.empresas.length > 1

    return (
      <header className={`vx-header${dev ? ' vx-dev' : ''}`}>
        {/* Hamburger */}
        <button
          className="vx-header-toggle"
          onClick={this.props.onToggleSidebar}
          title="Menu"
        >
          <i className="material-icons">menu</i>
        </button>

        {/* Dev badge */}
        {dev && <span className="vx-dev-badge">SANDBOX</span>}

        {/* Company selector */}
        {empresaSelecionada && (
          podeTrocarEmpresa
            ? (
              <button
                className="vx-header-company"
                onClick={() => this.mudarAtuacao()}
                title="Trocar empresa"
                style={{ border: 'none' }}
              >
                <i className="material-icons vx-header-company-icon">business</i>
                <span className="vx-header-company-name">{nomeEmpresa}</span>
                <i className="material-icons vx-header-company-arrow">expand_more</i>
              </button>
            )
            : (
              <div className="vx-header-company" style={{ cursor: 'default' }}>
                <i className="material-icons vx-header-company-icon">business</i>
                <span className="vx-header-company-name">{nomeEmpresa}</span>
              </div>
            )
        )}

        <div className="vx-header-spacer" />

        {/* Bell */}
        <div className="vx-header-bell" title="Notificações">
          <i className="material-icons">notifications_none</i>
        </div>

        {/* User */}
        <div
          className="vx-header-user"
          onClick={() => this.setState(s => ({ dropdownOpen: !s.dropdownOpen }))}
          ref={this.dropdownRef}
        >
          <div className="vx-header-avatar">{siglaUsuario}</div>
          <div className="vx-header-user-info">
            <span className="vx-header-greeting">{this.saudacao()}</span>
            <span className="vx-header-name">{nomeUsuario}</span>
          </div>

          {this.renderDropdown()}
        </div>
      </header>
    )
  }
}

export function mapStateToProps (state) {
  const { authentication: { nomeUsuario, empresas } } = state
  return {
    siglaUsuario: `${firstLetter(nomeUsuario)}${secondLetter(nomeUsuario)}`,
    nomeUsuario: capitalizarTodasPrimeirasLetras(nomeUsuario),
    empresas,
    empresaSelecionada: recuperaEmpresaSelecionada() || state.empresaSelecionada,
    origem: state.origem,
    destino: state.destino,
    dataIda: state.dataIda,
    online: state.conexao ? state.conexao.online : true
  }
}

export default withRouter(connect(mapStateToProps, {
  alterarEmpresaSelecionada,
  selecionarRota,
  limparItinerarios,
  logoutUser
})(BarraNavegacao))
